import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useLessonContext } from '@hooks/lessons/lesson-context.hook'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * Every tab of the lesson page: starts the lesson read and lets the navigation go on at once. Between tabs of the
 * same lesson, and when only its query changes, nothing is reread; arriving from anywhere else rereads it, in case
 * it changed meanwhile. On a first load `from` matches `to` and so counts as the same lesson: the store is empty
 * then, and the hook reads it regardless.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) => {
  const disciplineId = to.params.id
  const lessonId = to.params.lessonId

  if (typeof disciplineId !== 'string' || typeof lessonId !== 'string' || !disciplineId || !lessonId) return

  const isSameLesson = from.params.id === disciplineId && from.params.lessonId === lessonId

  void useLessonContext().loadLesson(disciplineId, lessonId, { force: !isSameLesson })
})
